<template>
  <div class="results">
    <div class="results__item" v-for="item in results" :id="id(item.id)"
         :style="{order: itemOrder(item.id)}">
      <div class="category">{{ item.name }}</div>
      <div class="name">{{ item.result }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'resultsList',
  props: {
    results: Array,
  },
  methods: {
    id(itemId) {
      return itemId.toLowerCase().split(' ').join('-');
    },
    itemOrder(itemId) {
      return parseInt(itemId);
    }
  },
};
</script>

<style scoped lang="scss">
@import '../../../sass/setup.scss';

.results {
  position: relative;
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @include up-tablet {
    padding: 0;
  }

  &::after {
    @include pseudo();
    left: 0;
    bottom: 0;
    width: 100%;
    height: 2px;
    background-color: $c-white;
    pointer-events: none;
  }

  &__item {
    padding: 8.5px 5px 6.5px;
    display: grid;
    grid-template-columns: 113.38px 1fr;
    grid-column-gap: 26.69px;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);

    @include up-tablet {
      grid-template-columns: 88px 1fr;
      grid-column-gap: 16px;
    }

    .category {
      font-family: $f-neutraBook;
      font-size: 14px;
      line-height: 20px;
      text-transform: uppercase;
    }

    .name {
      max-width: 100%;
      font-family: $f-bellReg;
      font-size: 13px;
      line-height: 15px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
